import request from '@/utils/request'

/** 公开工具目录：EXE + AIP，一次返回 */
export function fetchToolCatalog() {
  return request.get('/plugin/public/catalog')
}

/** AIP 插件详情（含版本列表） */
export function fetchAipPluginDetail(pluginKey) {
  return request.get(`/aip-plugin/detail/${encodeURIComponent(pluginKey)}`)
}
